import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swb-newsletter',
  templateUrl: './newsletter.component.html'
})
export class NewsletterComponent implements OnInit {

  public subscribersQuery: string;
  public campaignsQuery: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filterSubscribers(query: string): void {
    this.subscribersQuery = query;
  }

  public filterCampaigns(query: string): void {
    this.campaignsQuery = query;
  }

}
